"use strict";
// @ts-ignore
try {
    self['workbox:core:6.5.3'] && _();
}
catch (e) { }
